// extracted by mini-css-extract-plugin
module.exports = {"modal-dialog":"styles_modal-dialog__1rSN0","email-errors":"styles_email-errors__2Ksnc","email-error":"styles_email-error__2V0TF","error":"styles_error__11Fiq"};